import { render, staticRenderFns } from "./FormularioProntoView.vue?vue&type=template&id=554371fc&"
import script from "./FormularioProntoView.vue?vue&type=script&lang=ts&"
export * from "./FormularioProntoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports